var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationEmptyStateComments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #212529;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #eef0f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -0.26,
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1365",
    "data-name": "Elipse 1365",
    className: "cls-4",
    cx: 48,
    cy: 48,
    r: 38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.98,8.73l-45.67,7.72c-3.14,.53-5.27,3.53-4.74,6.67l8.68,51.38,9.49-13.35,39.96-6.75c3.14-.53,5.27-3.53,4.74-6.67l-5.79-34.25c-.53-3.14-3.53-5.27-6.67-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.92,75.9L16.02,23.21c-.58-3.45,1.75-6.72,5.19-7.31l45.67-7.72c1.66-.28,3.34,.1,4.72,1.09,1.38,.98,2.3,2.44,2.58,4.1l5.79,34.25c.58,3.45-1.75,6.72-5.19,7.31l-39.74,6.72-10.12,14.24ZM67.95,9.19c-.29,0-.58,.02-.88,.07l-45.67,7.72c-2.85,.48-4.78,3.19-4.3,6.04l8.46,50.08,8.85-12.46,.22-.04,39.96-6.75c2.85-.48,4.78-3.19,4.29-6.04l-5.79-34.25c-.23-1.37-.99-2.58-2.14-3.39-.9-.64-1.95-.98-3.03-.98Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11654",
    "data-name": "Grupo 11654"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1366",
    "data-name": "Elipse 1366",
    className: "cls-2",
    cx: 48.81,
    cy: 36.79,
    r: 3.26
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1367",
    "data-name": "Elipse 1367",
    className: "cls-2",
    cx: 36.32,
    cy: 38.9,
    r: 3.26
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1368",
    "data-name": "Elipse 1368",
    className: "cls-2",
    cx: 61.31,
    cy: 34.68,
    r: 3.26
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEmptyStateComments);
export default __webpack_public_path__ + "static/media/illustration_empty-state-comments.a822e321f6b943f41de8f49e6a40fd5b.svg";
export { ForwardRef as ReactComponent };